import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ButtonLargeWeb } from "../../../../../components/ButtonLargeWeb";
import { ComponenteTabsWeb } from "../../../../../components/ComponenteTabsWeb";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const CorporativoBusinessBankingStepperWeb = () => {
  const colors = useDynamicColors();

  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/business_banking-mail-corporativo-web${currentParams}`);
  };

  const laptop = {
    marginTop: "30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#333",
    borderRadius: "15px 15px 5px 5px",
    padding: "17px",
    width: "1400px",
    height: "800px",
    position: "relative",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  };

  const screen = {
    backgroundColor: "white",
    borderRadius: "5px",
    overflowY: "scroll",
    overflowX: "hidden",
    width: "100%",
    height: "800px",
  };

  const container = {
    display: "flex",
    height: "100vh",
  };

  const base = {
    position: "absolute",
    width: "1600px",
    height: "20px",
    backgroundColor: "rgb(170, 170, 170)",
    borderRadius: "0px 0px 10px 10px",
    bottom: 0,
  };

  return (
    <div style={laptop}>
      <div style={screen}>
        <div style={container}>
          <div className="corporativo-business-stepper">
            <div className="overlap-wrapper">
              <div className="overlap">
                <div className="overlap-group">
                  <div className="rectangle-cbblw" />

                  <div className="frame-2">
                    <ComponenteTabsWeb
                      atomoTabDivClassName="componente-tabs-web-2"
                      atomoTabDivClassNameOverride="componente-tabs-web-2"
                      atomoTabFrameClassName="componente-tabs-web-instance"
                      atomoTabFrameClassNameOverride="componente-tabs-web-3"
                      atomoTabLine="/img/line-49-2.svg"
                      atomoTabText="Sign up"
                      className="design-component-instance-node"
                    />
                    <div className="title-step">
                      <div className="subtitle-222">Welcome!</div>

                      <p className="p">
                        Start the VERIBANK Business experience
                      </p>
                    </div>

                    <div className="steps-box">
                      {[
                        "Enter Employer Indentification Number",
                        "Register your Email",
                        "Select your product",
                        "Accept Terms and Conditions",
                        "Validate your identity",
                        "Generate your password",
                        "Fill in your company information",
                        "Attach the required documents",
                      ].map((text, index) => (
                        <div className="step" key={index}>
                          <div className="circle">{index + 1}</div>
                          <span className="step-text">{text}</span>
                        </div>
                      ))}
                    </div>
                    <div className="reminder">
                      <div
                        role="img"
                        aria-label="megaphone"
                        style={{ dispaly: "flex", placeContent: "center" }}
                      >
                        <img src="/img/aviso.png" height={20} width={20} />
                      </div>
                      <div style={{ dispaly: "flex", placeContent: "center" }}>
                        <span>
                          <strong> Remember</strong>, after completing the
                          application, an executive will contact you.
                        </span>
                      </div>
                    </div>

                    <div onClick={handleButtonClick}>
                      <ButtonLargeWeb
                        className="button-large-WEB-instance"
                        iconLeft={false}
                        iconRigth={false}
                        primarioActive={false}
                        primarioInactive={false}
                        secundarioActive={false}
                        secundarioInactive
                        terciarioActive={false}
                        terciarioInactive={false}
                        text="Continue"
                      />
                    </div>
                  </div>

                  <div className="div-wrapper-login-bb">
                    <p className="text-2">
                      <span className="span">
                        Already started an application?
                      </span>

                      <span className="text-wrapper-2">Click here</span>
                    </p>
                  </div>

                  <div className="group">
                    <div className="frame-4">
                      © 2025 All rights reserved
                      <img width={100} height="auto" src="/img/veritran.svg" />
                      Innovation Lab
                    </div>
                  </div>

                  <div className="component">
                    {colors.url_logo !== "" && (
                      <img width={30} height="auto" src={colors.url_logo} />
                    )}
                    <div className="language">
                      <img
                        src="https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us"
                        height={30}
                        width={30}
                      />
                    </div>
                  </div>
                </div>

                <div className="slider-wrapper">
                  <div className="slider">
                    <div className="imagen-slider">
                      <div className="imagen-texto">
                        <div className="mobile-login-pana-wrapper">
                          <div className="mobile-login-pana">
                            <div className="overlap-2">
                              <img
                                className="freepik-background"
                                alt="Freepik background"
                                src="/img/imagen-login.png"
                              />

                              <div className="rectangle-2" />
                            </div>
                          </div>
                        </div>

                        <div className="texto">
                          <div className="subtitle-2">
                            VERIBANK <br />
                            Safety Tips!
                          </div>

                          <p className="subtitle-3">Learn more</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={base}></div>
    </div>
  );
};
